<template>
    <div>
      <v-ons-toolbar style="height:50px;padding:2px 6px;">
        <div class="left">
          <!--<v-ons-back-button class="btn_back" v-if="mode=='back'">{{ $store.getters.localizeLabel("Common", "back")}}</v-ons-back-button>-->
          <v-ons-button class="btn_back" v-if="mode=='back' || mode=='order'" modifier="quiet" @click="popPage"><v-ons-icon icon="fa-chevron-left"></v-ons-icon> {{ $store.getters.localizeLabel("Common", "back")}}</v-ons-button>

          <v-ons-button class="btn_back" v-if="mode=='top'" modifier="quiet" @click="navigateWPPage('menu_top')"><v-ons-icon icon="fa-chevron-left"></v-ons-icon> {{ $store.getters.localizeLabel("Tabbar", "home")}}</v-ons-button>

          <div class="toolheader_block" v-if="mode=='normal'">
            <div class="header_label">
              <span class="title">{{ $store.getters.localizeLabel("Toolbar", "table_no")}}</span><!--卓番号-->
              <span class="number">{{TableNo}}</span>
            </div>
            <div class="header_label">
              <span class="title">{{ $store.getters.localizeLabel("Toolbar", "slip_no")}}</span><!--伝票番号-->
              <span class="number">{{SlipNo}}</span>
            </div>
          </div>
          
        </div>
        <div class="center header_title" :class="{extend_menu:$store.getters.SubMenuList.length>=1}">
          <slot></slot>
        </div>
        <div class="right" :class="{extend_menu:$store.getters.SubMenuList.length>=1}">
          
          <v-ons-toolbar-button v-if="mode!='back' && mode!='order' && isLanguageMenuEnabled()" @click="showPopover($event, 'down', true)" style="display:flex; justify-content:flex-end;">
            <v-ons-icon v-if="$ons.platform.isAndroid()" icon="md-more-vert"></v-ons-icon>
            <span class="lang_text" v-else><img src="../assets/img/lang.svg" style="margin-right:5px" alt="">{{currentLangName}}</span>
          </v-ons-toolbar-button>

          <!--放題メニューボタン(1つ)-->
          <div class="extend_menu_block" v-if="mode!='order'">
              <v-ons-button modifier="quiet" class="btn_extend_menu" style="flex:1"  @click="moveExMenu($store.getters.SubMenuList[0])" :class="{active: $store.getters.currentMenu=='menu'}" v-if="$store.getters.SubMenuList.length==1">
              <div class="toolbar_btn extend_menu">
                <span v-if="$store.getters.currentLangCode=='ja'" class="menu_label" v-html="$store.getters.SubMenuNameJp"></span>
                <span v-if="$store.getters.currentLangCode=='en'" class="menu_label" v-html="$store.getters.SubMenuNameEn"></span>
                <span v-if="$store.getters.currentLangCode=='ch'" class="menu_label" v-html="$store.getters.SubMenuNameCh"></span>
              </div>
            </v-ons-button>
            <!--放題メニューボタン(複数)-->
            <v-ons-button modifier="quiet"  class="btn_extend_menu" style="flex:1"   @click="openSubmenuAction()" v-if="$store.getters.SubMenuList.length>1">
              <div class="toolbar_btn extend_menu">
                <span v-if="$store.getters.currentLangCode=='ja'" class="menu_label" v-html="$store.getters.SubMenuNameJp"></span>
                <span v-if="$store.getters.currentLangCode=='en'" class="menu_label" v-html="$store.getters.SubMenuNameEn"></span>
                <span v-if="$store.getters.currentLangCode=='ch'" class="menu_label" v-html="$store.getters.SubMenuNameCh"></span>
              </div>
            </v-ons-button>
          </div>
            
          
        </div>
      </v-ons-toolbar>
      <v-ons-popover cancelable
          :visible.sync="popoverVisible"
          :target="popoverTarget"
          :direction="popoverDirection"
          :cover-target="coverTarget"
        >
        <v-ons-list style="background:white">
            <v-ons-list-item style="color:#222; padding-right:10px" tappable @click="changeLang('ja')">日本語</v-ons-list-item>
            <v-ons-list-item style="color:#222; padding-right:10px" tappable @click="changeLang('en')">English</v-ons-list-item>
            <!--<v-ons-list-item style="color:#222; padding-right:10px" tappable @click="changeLang('ch')">中 文</v-ons-list-item>-->
        </v-ons-list>
      </v-ons-popover>
    </div>
    

</template>

<script>
import { mapGetters,mapActions } from "vuex";
import setting from '../ms.config';
export default {
  name: 'msToolbar',
  props: {
    title: { type: String, default: '' },
    mode: { type: String, default: 'normal' },
  },
  data () {
    return {
      popoverVisible: false,
      popoverTarget: null,
      popoverDirection: 'up',
      coverTarget: false
    }
  },
  computed: {
    ...mapGetters([
      'SlipNo',
      'TableNo',
      'currentLangName',
      'SubMenuName',
      ]),
  },
  methods: {
    ...mapActions([
      'popPage',
      "setLanguage",
      'navigateWPPage',
      'showErrorMessage',
      'getWPAllPageList',
    ]),
    isLanguageMenuEnabled(){
        return setting.ENV.LANGUAGE_LINK_ENABLED
      },
    moveExMenu(submenu){
      //放題メニューの時間制限チェック
      //制限時間チェック
        if(this.$store.getters.CheckTheSubmenuEndtime(submenu)==false){
          this.actionSheetVisible=false
          this.showErrorMessage(submenu.GoodsName+"の商品は制限時間が過ぎているため注文できません")
          
        }else{
          this.navigateWPPage(submenu.Goods)
          .then(()=>{
            this.SetCurrentSubmenu(submenu)
            this.actionSheetVisible=false
          })
          .catch(error=>{

          })
        }
    },
    /**
     * Storeのサブメニューが反映されないので、動的にActionSheetを作成する
     */
    openSubmenuAction(){
      //this.refresh=true
      var buttons=[]
      var button_count=0
      var self=this
      this.$store.getters.SubMenuList.forEach(function(item){
        switch (self.$store.getters.currentLangCode){
          case 'ja':
            buttons.push({submenu:item ,label: item.GoodsName})
            break
          case 'en':
            buttons.push({submenu:item ,label: item.GoodsNamee})
            break
          case 'ch':
            buttons.push({submenu:item ,label: item.GoodsNamec})
            break
        }
        button_count++
      })
      buttons.push({
          label: this.$store.getters.localizeLabel("Common", "close"),
          icon: 'md-close'
      })
      this.$ons.openActionSheet({
        title: this.$store.getters.localizeLabel("Tabbar", "submenu_action_titile"),
        cancelable: true,
        buttons: buttons
      }).then(function (index) { 
        if(index==button_count){
          //cancel
        }else{
          self.moveExMenu(buttons[index].submenu)
        }
        //console.log('index: ', index) 
      });
      
    },
    showPopover(event, direction, coverTarget = false) {
      this.popoverTarget = event;
      this.popoverDirection = direction;
      this.coverTarget = coverTarget;
      this.popoverVisible = true;
    },
    changeLang(lang){
      this.setLanguage(lang)
      .then(()=>{
        this.popoverVisible=false
        this.getWPAllPageList() //全メニューリスト取得
        //メニュートップへ戻って言語ページを再読み見込み
        this.navigateWPPage('menu_top')
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/sass/base.scss";
  
  ons-toolbar{
    //background: black;
    background: $header-bg;
    color: $header-font-color;
   // border-bottom: 1px solid gray;
  }
  ons-toolbar-button{
    display: flex;
    align-content: center;
    padding: 0 5px;
  }
  .lang_text{
    color: $header-font-color!important;
  }
  .btn_back{
    color: $header-font-color!important;
    font-size: 15px!important;
  }
  .toolbar_inner{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .toolheader_block{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .header_label{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    flex: 1;
    margin-right: 15px;
    .title{
      color: $header-font-color;
      font-size: 10px;
      line-height: 1;
      margin-right: 5px;
    }
    .number{
      color: $header-font-color;
      font-weight: bold;
      font-size: 20px;
      line-height: 1;
    }
  }
  .extend_menu_block{
    padding: 3px 0;
   
    ons-button{
      border-radius: 5px;
      background: linear-gradient( #f86415,#c44704) ;
      color: $header-font-color;
      font-size: 11px;
      font-weight: 500;
      display: block;
      height: 42px;
      .menu_label{
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: normal;
        word-break: break-all;
        line-height: 1.3;
        text-align: left;
        height: 38px;
      }
      

    }
  }
  .right.extend_menu{
    width: 47%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .center.extend_menu{
    width: 30%;
  }
  .header_title{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/msToolbar.vue